module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADYSURBVDiN1ZTBbcJAEEXf93pXPjoVxKkA0UEK4AAduIR0gFIBpBLngOtAVIBLIFcbMzkkJJHFAZy98I672qf9+qNRHdweVBAFa1Kz5E2cJlF8UhPFc1+o9q5Eerz2gZk+Zl23Hp5XGUXo3bPGtNy2x6cF/BSw8f5F2BKRp23bT4H8Bt9hAQeACvIQ3AqsPF/qlp/95Vu2HaZLxgrJLqdS9RV3fGTvVki/kUeW8nCWMiwF4xVx9dhcYtZ16yrj3fd+/h/PnaI6pEvMouxDI9mlYCWKs2DFqfkESMFBYmeAcMUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/路径.png
// module id = z3+r
// module chunks = 1